import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ChevronRight, SlidersIcon, XIcon } from 'lucide-react'
import { useState } from 'react'

export function AccordionItemWrapper({ children, title, value }) {
  return (
    <AccordionItem value={value} className="nmb border-neutral-blue-700!">
      <AccordionTrigger
        iconClassName="stroke-shades-0! size-6!"
        className="text-p-3 font-semibold"
      >
        {title}
      </AccordionTrigger>
      <AccordionContent className="mb-2 flex flex-col gap-3 text-p-2 font-semibold">
        {children}
      </AccordionContent>
    </AccordionItem>
  )
}

export default function MobileFilterWrapper({ children, onClear, onApply }) {
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false)

  async function handleMobileFilterClear() {
    if (onClear) onClear()
  }

  async function handleApply() {
    if (onApply) onApply()
    setMobileFilterOpen(false)
  }

  return (
    <>
      <button
        onClick={() => setMobileFilterOpen(!mobileFilterOpen)}
        className="col-span-full flex h-[52px] items-center justify-between rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 px-6 desktop-xs:hidden"
      >
        <div className="flex items-center gap-2">
          <SlidersIcon className="size-5 stroke-neutral-blue-200" />
          <p className="text-p-1 font-semibold">Filter</p>
          {/* TODO Show count of applied filters */}
        </div>
        <ChevronRight className="size-4 stroke-shades-0" />
      </button>
      <div
        className={cn(
          'fixed inset-0 z-20 flex h-dvh max-h-dvh flex-col justify-between overflow-y-auto bg-neutral-blue-900 px-6 pb-11 pt-[70px]',
          {
            hidden: !mobileFilterOpen,
          },
        )}
      >
        <div className="flex flex-1 flex-col">
          <div className="flex items-center justify-between">
            <p className="text-h-2-sm font-bold">Filter</p>
            <button
              onClick={() => {
                handleMobileFilterClear()
                setMobileFilterOpen(false)
              }}
            >
              <XIcon className="size-10 stroke-shades-0" />
            </button>
          </div>
          <div className="divide mt-6 bg-neutral-blue-700" />
          <div className="flex-1">{children}</div>
        </div>

        <div className="mt-6 flex h-[62px] justify-between gap-4">
          <Button
            onClick={handleMobileFilterClear}
            variant="secondary"
            className="flex-1"
          >
            Clear
          </Button>
          <Button className="flex-1" onClick={handleApply}>
            Apply
          </Button>
        </div>
      </div>
    </>
  )
}
